export default function ComparisonBenefits({ title, subtitle, benefits }) {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-base-white">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-inter text-[24px] sm:text-[32px] lg:text-[38px] font-black tracking-[-1.5px] leading-[1.15] mb-4 text-center fade-in">
          {title}
        </h2>
        <p className="font-inter text-base text-gray-cool-500 leading-[1.7] max-w-[700px] mx-auto mb-12 text-center fade-in">
          {subtitle}
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 fade-in">
          {benefits.map((benefit, i) => (
            <div
              key={i}
              className="text-center p-6 sm:p-8 bg-base-white rounded-2xl border border-gray-cool-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_28px_rgba(0,0,0,0.06)] hover:border-transparent"
            >
              <div
                className={`w-14 h-14 rounded-[14px] flex items-center justify-center text-2xl mx-auto mb-4 ${
                  i % 2 === 0
                    ? "bg-blue-primary-500/10 text-blue-primary-500"
                    : "bg-semantic-negative-500/10 text-semantic-negative-500"
                }`}
              >
                {benefit.icon}
              </div>
              <h4 className="font-inter text-[15px] font-bold tracking-[-0.2px] mb-1.5">
                {benefit.title}
              </h4>
              <p className="font-inter text-[13px] text-gray-cool-500 leading-[1.5]">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
